import React from 'react';
import QuotationWorkflowPage from '../components/QuotationBuilder/QuotationWorkflowPage';

const CreateQuotationPage: React.FC = () => <QuotationWorkflowPage />;

export default CreateQuotationPage;
